import React from "react";

import * as d3 from "d3";

import Ruler from "src/organization/pages/project/environment/metrics/http/components/ruler";
import Yaxis from "src/organization/pages/project/environment/metrics/http/components/Yaxis";
import {
  getLayoutPositions,
  move
} from "src/organization/pages/project/environment/metrics/http/helper/index";
import useUpdateDimension from "src/organization/pages/project/environment/metrics/http/hook/useUpdateDimension";

import { margin } from "../settings";

const DEFAULT_LEFT_TICKS = 6;

type VerticalAxisProps = {
  transform?: string;
  chartId?: string;
  yFormatter: () => string;
  data?: Array<{ [v in string]: string }>;
  overComitInfo?: {
    fixedMax: number;
    hasOverCommit: boolean;
    max: number;
    reportedMax: number;
  };
  yAxis?: d3.ScaleLinear<number, number>;
  xAxis?: d3.ScaleTime<number, number>;
};
const VerticalAxis = ({
  yAxis,
  yFormatter,
  xAxis,
  chartId
}: VerticalAxisProps) => {
  const id = `chart-${chartId}`;
  const dim = useUpdateDimension(id, margin);
  const position = getLayoutPositions({
    ...dim,
    width: (dim.width || 0) - margin.left
  });
  const maxPoint = yAxis?.domain()[1];

  return yAxis ? (
    <>
      <Ruler
        id={id}
        position={position}
        ticksCount={DEFAULT_LEFT_TICKS}
        xScale={xAxis}
        yScale={yAxis}
        max={maxPoint}
        transform={position.yTransform}
      />
      <Yaxis
        numProgression={DEFAULT_LEFT_TICKS}
        xAxis={xAxis}
        yAxis={yAxis}
        maxPoint={maxPoint}
        transform={move(0, 10)}
        format={yFormatter}
      />
    </>
  ) : null;
};

export default VerticalAxis;
